// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2i5SU","colBig":"styles_colBig__14CNv","colSmall":"styles_colSmall__31CMo"};